import Vue from 'vue';
import sensors from '/static/lib/sensors/sensorsdata.es6.min'
import Settings from 'settings';
import store from '@/store'

/*为抹平新门户/数字门户/未来门户等的差异*/

// 初始化sdk
sensors.init({
    server_url: Settings.present.sensors, // 上报地址
    show_log: false
})


const getPublicInfo = () => {
    const { tenantJson, userdata } = store.state.user // 公共属性需要的参数来源
    console.log(tenantJson, userdata, 'sensor clock')
    if (tenantJson && userdata) {
        // 注册公共属性
        sensors.registerPage({
            member_id: userdata.memberCode, // 会员id
            // cust_id: userdata.custId, // 客户ID
            tenant_id: userdata.tenantId, // 租户id
            product_instance_code: tenantJson.bossProductInstance, // 产品实例CODE
            menhu_template_code: tenantJson.templateCode, // 产品编码（产品分类）
            menhu_product_name: tenantJson.name, // 产品名称
            instance_language: tenantJson.language, // 语言
            instance_website: tenantJson.domain, // 实例网址
            unittype: tenantJson.unittype // unittype 产品线？ 唯一标识 可根据这个区分渠道
        })
        clearInterval(clock)
        
        // 设置用户 ID
        sensors.login(userdata.custId)

        window.ceSensors = sensors // 挂在到window上

        Vue.prototype.$ceTrack = (event, data) => {
            sensors.track(event, data)
        }

    }
}

let clock = setInterval(getPublicInfo, 1000);